import { render } from "./Bedarfsanmeldungen.vue?vue&type=template&id=106c6e14"
import script from "./Bedarfsanmeldungen.vue?vue&type=script&lang=js"
export * from "./Bedarfsanmeldungen.vue?vue&type=script&lang=js"

import "./Bedarfsanmeldungen.vue?vue&type=style&index=0&id=106c6e14&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__